/**
 * Adds the ability to toggle between the catalog and website search.
 */
Drupal.behaviors.toggleSearch = {
  attach: (context) => {
    if (context === document) {
      // Retrieve the collapsable elements.
      const $catalog = $('#lm-search-catalog', context);
      const $database = $('.lm-search-database', context);

      // Close the database form and open the catalog form when the catalog
      // toggle is clicked.
      $('#catalog-toggle').on('click', (event) => {
        event.preventDefault();

        $('#database-toggle').removeClass('is-active');
        $(event.currentTarget).addClass('is-active');
        $database.collapse('hide');
        $catalog.collapse('show');
      });

      // Close the catalog form and open the database form when the database
      // toggle is clicked.
      $('#database-toggle').on('click', (event) => {
        event.preventDefault();

        $('#catalog-toggle').removeClass('is-active');
        $(event.currentTarget).addClass('is-active');
        $catalog.collapse('hide');
        $database.collapse('show');
      });
    }
  },
};

/**
 * Opens the catalog home page if no search results were entered.
 */
Drupal.behaviors.modifyCatalogSearch = {
  attach: (context) => {
    // Listen for when the catalog search form is submitted.
    $('#globalSearch', context).submit((ev) => {
      // Retrieve the user's search input if there was any.
      const input = $('.lm-catalog-search-input', context).val();
      // Check if the user entered anything into the search box.
      if (!input) {
        // Prevent the form from submitting.
        ev.preventDefault();
        // Open the catalog home page in a new tab.
        window.open('https://ccs.polarislibrary.com/polaris/default.aspx?ctx=37.1033.0.0.43', '_blank');
      }
    });
  },
};
